import React, { useState, useEffect, useRef, useCallback } from "react";
import { useToast } from "../../Utils/toastContext";
import { useNavigate, useLocation } from "react-router-dom";
import { debounce } from "lodash";
import PercentageInputField from "../../Components/fee-input/fee-input";
import DocumentPreview from "../Create-Investment/documentpreview";

const BASE_URL = process.env.REACT_APP_BASE_URL;
const ProductSettings = () => {
  const navigate = useNavigate();
  const { showToast } = useToast();
  const [directCredit, setDirectCredit] = useState("");
  const [directDebit, setDirectDebit] = useState("");
  const [domesticPayment, setDomesticPayment] = useState("");
  const [productAllocation, setProductAllocation] = useState("");
  const [brokerageFees, setBrokerageFees] = useState("");
  const [startTime, setStartTime] = useState("");
  const [endTime, setEndTime] = useState("");
  const [custodyFee, setCustodyFee] = useState("");
  const [accountKeepingFee, setAccountKeepingFee] = useState("");
  const [managementCost, setManagementCost] = useState("");
  const [smAgreement, setSmAgreement] = useState("");
  const [directDebitAgreement, setDirectDebitAgreement] = useState("");
  const [fileIndemnityForm, setFileIndemnityForm] = useState("");
  const [cashAccountAgreement, setCashAccountAgreement] = useState("");
  const [fileCrs, setFileCrs] = useState("");
  const [agreements, setAgreements] = useState([]);

  const [
    internationalPaymentWithConversion,
    setInternationalPaymentWithConversion,
  ] = useState("");
  const [internationalPayment, setInternationalPayment] = useState("");
  const [comments, setComments] = useState("");
  const [isLoading, setIsLoading] = useState(false);
  const [settingData, setData] = useState([]);
  const [loading, setLoading] = useState(false);
  const [ranges, setRanges] = useState([
    { start: "", end: "", rate: "", error: { start: "", end: "", rate: "" } },
    { start: "", end: "", rate: "", error: { start: "", end: "", rate: "" } },
    { start: "", end: "", rate: "", error: { start: "", end: "", rate: "" } },
    { start: "", end: "", rate: "", error: { start: "", end: "", rate: "" } },
  ]);
  const [directDebitError, setDirectDebitError] = useState("");
  const [directCreditError, setDirectCreditError] = useState("");
  const [domesticPaymentError, setDomesticPaymentError] = useState("");
  const [
    internationalPaymentWithConversionError,
    setInternationalPaymentWithConversionError,
  ] = useState("");
  const [accountKeepingFeeError, setAccountKeepingFeeError] = useState("");
  const [internationalPaymentError, setInternationalPaymentError] =
    useState("");
  const [managementCostError, setManagementCostError] = useState("");
  const [brokerageFeesError, setBrokerageFeesError] = useState("");
  const [custodyFeeError, setCustodyFeeError] = useState("");
  const [productAllocationError, setProductAllocationError] = useState("");
  const fileSmaRef = useRef(null);
  const fileDirectDebitRef = useRef(null);
  const fileCashAccountRef = useRef(null);
  const fileCrsRef = useRef(null);
  const fileFormRef = useRef(null);
  const [currentField, setCurrentField] = useState({});
  const [currentFieldName, setCurrentFieldName] = useState("");
  const [currentFieldValue, setCurrentFieldValue] = useState("");
  const [currentFieldType, setCurrentFieldType] = useState("");


  const handleChange = (index, field, value) => {
    const updated = [...ranges];
    updated[index][field] = value;

    const start = parseFloat(updated[index].start);
    const end = parseFloat(updated[index].end);
    const rate = parseFloat(updated[index].rate);

    const error = { ...updated[index].error };

    // Validate start < end
    if (!isNaN(start) && !isNaN(end)) {
      error.start = start >= end ? "Start must be less than end" : "";
      error.end = start >= end ? "End must be greater than start" : "";
    } else {
      error.start = "";
      error.end = "";
    }

    // Validate rate <= 100
    if (field === "rate") {
      if (isNaN(rate)) {
        error.rate = "Please enter a valid rate";
      } else if (rate > 100) {
        error.rate = "Rate must not exceed 100";
      } else {
        error.rate = "";
      }
    }

    updated[index].error = error;
    setRanges(updated);
  };

  const GetAPIcalls = async (url) => {
    const token = localStorage.getItem("jwtToken");
    const apiUrl = `${BASE_URL}${url}`;
    const headers = {
      "Content-Type": "application/json",
    };

    if (token) {
      headers.Authorization = `Bearer ${token}`;
    }

    try {
      const response = await fetch(apiUrl, {
        method: "GET",
        headers,
      });

      if (!response.ok) {
        if (response.status === 401) {
          localStorage.removeItem("jwtToken");
          navigate("/login");
          throw new Error("Session expired. Please log in again.");
        }
        const errorData = await response.json().catch(() => ({
          message: "An unexpected error occurred",
        }));
        throw new Error(errorData.message || "Something went wrong");
      }
      return await response.json();
    } catch (error) {
      console.error("API Call Error:", error); // Log full error for debugging
      throw new Error(
        typeof error.message === "string"
          ? error.message
          : "Network error, please try again later"
      );
    }
  };
  const getSettingsData = async () => {
    setIsLoading(true);
    try {
      const response = await GetAPIcalls(`/v1/settings/all`);
      if (response.status == 200) {
        const directCreditFee = response.data.find(
          (item) => item.name === "DIRECT_CREDIT_FEE"
        );
        setDirectCredit(parseFloat(directCreditFee.value).toFixed(2) || "");
        const directdebitFee = response.data.find(
          (item) => item.name === "DIRECT_DEBIT_FEE"
        );
        setDirectDebit(parseFloat(directdebitFee.value).toFixed(2) || "");
        const domesticPaymenth = response.data.find(
          (item) => item.name === "DOMESTIC_PAYMENT_RTGS_FEE"
        );
        setDomesticPayment(parseFloat(domesticPaymenth.value).toFixed(2) || "");

        const internationalPaymenth = response.data.find(
          (item) => item.name === "INTERNATIONAL_PAYMENT_WITHOUT_CONVERSION"
        );
        setInternationalPayment(
          parseFloat(internationalPaymenth.value).toFixed(2) || ""
        );

        const internationalPaymentWithConversion = response.data.find(
          (item) => item.name === "INTERNATIONAL_PAYMENT_WITH_CONVERSION"
        );
        setInternationalPaymentWithConversion(
          parseFloat(internationalPaymentWithConversion.value).toFixed(2) || ""
        );
        const brokerageFees = response.data.find(
          (item) => item.name === "BELL_DIRECT_BROKERAGE_FEE"
        );
        setBrokerageFees(parseFloat(brokerageFees.value).toFixed(2) || "");
        const nabComments = response.data.find(
          (item) => item.name === "BELL_DIRECT_COMMENTS"
        );
        setComments(nabComments.value || "");
        const custodyFees = response.data.find(
          (item) => item.name === "CUSTODY_FEE"
        );
        setCustodyFee(parseFloat(custodyFees.value).toFixed(2) || "");
        const accountKeepingFees = response.data.find(
          (item) => item.name === "ACCOUNT_KEEPING_FEE"
        );
        setAccountKeepingFee(
          parseFloat(accountKeepingFees.value).toFixed(2) || ""
        );
        const managementCostFees = response.data.find(
          (item) => item.name === "MANAGEMENT_COST"
        );
        setManagementCost(
          parseFloat(managementCostFees.value).toFixed(2) || ""
        );

        const productAllocation = response.data.find(
          (item) => item.name === "ALLOWED_ALLOCATION_CHANGE"
        );
        setProductAllocation(
          parseFloat(productAllocation.value).toFixed(2) || ""
        );
        const startTime = response.data.find(
          (item) => item.name === "ORDER_START_TIME"
        );
        setStartTime(startTime.value || "");
        const endTime = response.data.find(
          (item) => item.name === "ORDER_END_TIME"
        );
        setEndTime(endTime.value || "");
        const adminfees = response.data.find(
          (item) => item.name === "ADMINISTRATION_FEE"
        );
        const parsed = JSON.parse(adminfees.value);

        const withErrorField = parsed.map((item) => ({
          ...item,
          error: "",
        }));

        setRanges(withErrorField);
      } else {
        if (response.status === 401) {
          localStorage.removeItem("jwtToken");
          navigate("/login");
        }
        if (response.status === 400) {
          setData([]);
          showToast(response.message, "error");
        }
      }
    } catch (err) {
      if (err.status === 401) {
        localStorage.removeItem("jwtToken");
        navigate("/login");
      }
      setData([]);
      showToast(err.message, "error");
    } finally {
      setTimeout(function () {
        setIsLoading(false);
      }, 100);
    }
  };

  const getAllAgreements = async () => {
    setIsLoading(true);
    try {
      const response = await GetAPIcalls(
        `/v1/onboarding/agreements/admin/configs`
      );
      if (response.status == 200) {
        setAgreements(response.data?.agreements || []);
      } else {
        if (response.status === 401) {
          localStorage.removeItem("jwtToken");
          navigate("/login");
        }
        if (response.status === 400) {
          setData([]);
          showToast(response.message, "error");
        }
      }
    } catch (err) {
      if (err.status === 401) {
        localStorage.removeItem("jwtToken");
        navigate("/login");
      }
      setData([]);
      showToast(err.message, "error");
    } finally {
      setTimeout(function () {
        setIsLoading(false);
      }, 100);
    }
  };
  const UpdateSettings = async () => {
    const token = localStorage.getItem("jwtToken");
    const headers = {
      "Content-Type": "application/json",
    };

    if (token) {
      headers.Authorization = `Bearer ${token}`;
    }
    // CUSTODY_FEE
    // ACCOUNT_KEEPING_FEE
    //MANAGEMENT_COST
    const apiUrl = `${BASE_URL}/v1/settings/bulk-update`;
    const preparedValue = JSON.stringify(
      ranges.map(({ start, end, rate }) => ({
        start,
        end,
        rate,
      }))
    );
    const bodyData = {
      settings: [
        {
          name: "DIRECT_CREDIT_FEE",
          value: directCredit,
        },
        {
          name: "DIRECT_DEBIT_FEE",
          value: directDebit,
        },
        {
          name: "DOMESTIC_PAYMENT_RTGS_FEE",
          value: domesticPayment,
        },
        {
          name: "INTERNATIONAL_PAYMENT_WITHOUT_CONVERSION",
          value: internationalPayment,
        },
        {
          name: "INTERNATIONAL_PAYMENT_WITH_CONVERSION",
          value: internationalPaymentWithConversion,
        },
        {
          name: "BELL_DIRECT_BROKERAGE_FEE",
          value: brokerageFees,
        },
        {
          name: "BELL_DIRECT_COMMENTS",
          value: comments,
        },
        {
          name: "ALLOWED_ALLOCATION_CHANGE",
          value: productAllocation,
        },
        {
          name: "ORDER_START_TIME",
          value: startTime,
        },
        {
          name: "ORDER_END_TIME",
          value: endTime,
        },
        {
          name: "CUSTODY_FEE",
          value: custodyFee,
        },
        {
          name: "ACCOUNT_KEEPING_FEE",
          value: accountKeepingFee,
        },
        {
          name: "MANAGEMENT_COST",
          value: managementCost,
        },
        {
          name: "ADMINISTRATION_FEE",
          value: preparedValue,
        },
      ],
    };
    try {
      const response = await fetch(apiUrl, {
        method: "PUT",
        headers: headers,
        body: JSON.stringify(bodyData),
      });

      if (!response.ok) {
        if (response.status === 401) {
          localStorage.removeItem("jwtToken");
          navigate("/login");
          throw new Error("Session expired. Please log in again.");
        }
        const errorData = await response.json().catch(() => ({
          message: "An unexpected error occurred",
        }));
        throw new Error(errorData.message || "Something went wrong");
      }

      return await response.json();
    } catch (error) {
      throw new Error(error.message || "Network error, please try again later");
    }
  };
  const handleUpdateTransacion = useCallback(
    debounce(async (e) => {
      e.preventDefault();
      let toastMessage = null;
      try {
        const response = await UpdateSettings();
        if (response.status == 200) {
          toastMessage = { message: "Updated successfully", type: "success" };
        } else {
        }
      } catch (err) {
        toastMessage = { message: err.message, type: "error" };
      } finally {
        setLoading(false); // Ensure `loading` is false first
        // Show toast after loading is false
        if (toastMessage) {
          setTimeout(() => {
            showToast(toastMessage.message, toastMessage.type);
          }, 300); // Small delay if needed
        }
      }
    }, 1000), // Debounce time
    [
      directCredit,
      directDebit,
      domesticPayment,
      internationalPayment,
      internationalPaymentWithConversion,
      brokerageFees,
      productAllocation,
      startTime,
      endTime,
      custodyFee,
      accountKeepingFee,
      managementCost,
      ranges,
      comments,
    ] // Dependencies
  );
  const handleDeleteFileCRs = () => {
    setFileCrs(null);
    if (fileCrsRef.current) {
      fileCrsRef.current.value = null;
    }
  };
  const handleDeleteFileCashAccount = () => {
    setCashAccountAgreement(null);
    if (fileCashAccountRef.current) {
      fileCashAccountRef.current.value = null;
    }
  };
  const handleDeleteFileForm = () => {
    setFileIndemnityForm(null);
    if (fileFormRef.current) {
      fileFormRef.current.value = null;
    }
  };
  const handleDeleteFileDirectDebitAgreement = () => {
    setDirectDebitAgreement(null);
    if (fileDirectDebitRef.current) {
      fileDirectDebitRef.current.value = null;
    }
  };
  const handleDeleteFileSmAgreement = () => {
    setSmAgreement(null);
    if (fileSmaRef.current) {
      fileSmaRef.current.value = null;
    }
  };
  const fileUploadNew = async (file) => {
    const token = localStorage.getItem("jwtToken");
    const headers = {};

    if (token) {
      headers.Authorization = `Bearer ${token}`;
    }
    const apiUrl = `${BASE_URL}/v1/onboarding/upload/file`;
    const formData3 = new FormData();
    formData3.append("file", file); // Append file
    try {
      const response = await fetch(apiUrl, {
        method: "POST",
        headers,
        body: formData3,
      });
      if (!response.ok) {
        if (response.status === 401) {
          localStorage.removeItem("jwtToken");
          navigate("/login");
          throw new Error("Session expired. Please log in again.");
        }
        const errorData = await response.json().catch(() => ({
          message: "An unexpected error occurred",
        }));
        throw new Error(errorData.message || "Something went wrong");
      }
      return await response.json();
    } catch (error) {
      console.error("API Call Error:", error); // Log full error for debugging
      throw new Error(
        typeof error.message === "string"
          ? error.message
          : "Network error, please try again later"
      );
    }
  };

  // const fileUploadAgreement = async (file) => {
  //   const token = localStorage.getItem("jwtToken");
  //   const headers = {};

  //   if (token) {
  //     headers.Authorization = `Bearer ${token}`;
  //   }
  //   const apiUrl = `${BASE_URL}/v1/onboarding/agreements/${agreementType}/upload`;
  //        bodyData = {
  //         file_id:file
  //        }
  //   try {
  //     const response = await fetch(apiUrl, {
  //       method: "POST",
  //       headers,
  //       body: JSON.stringify(bodyData),
  //     });
  //     if (!response.ok) {
  //       if (response.status === 401) {
  //         localStorage.removeItem("jwtToken");
  //         navigate("/login");
  //         throw new Error("Session expired. Please log in again.");
  //       }
  //       const errorData = await response.json().catch(() => ({
  //         message: "An unexpected error occurred",
  //       }));
  //       throw new Error(errorData.message || "Something went wrong");
  //     }
  //     return await response.json();
  //   } catch (error) {
  //     console.error("API Call Error:", error); // Log full error for debugging
  //     throw new Error(
  //       typeof error.message === "string"
  //         ? error.message
  //         : "Network error, please try again later"
  //     );
  //   }
  // };
  const createFileChangeHandler =
    ({ inputRef, setFileState }) =>
    async (e) => {
      const selectedFile = e.target.files?.[0];
      let toastMessage = null;

      if (!selectedFile) return;

      const { type, size } = selectedFile;

      // Duplicate file name check
      if (checkFileNameExist(selectedFile)) {
        if (inputRef?.current) inputRef.current.value = null;

        showToast(
          "Please upload the required document; one file with the same name has already been uploaded.",
          "error"
        );
        return;
      }

      // File validation
      const isValidType = [
        "application/pdf",
        "image/png",
        "image/jpeg",
      ].includes(type);

      const isValidSize = size <= 10 * 1024 * 1024;

      if (!isValidType || !isValidSize) {
        showToast(
          "File must be PDF, PNG, or JPEG and less than 10MB.",
          "error"
        );
        return;
      }

      setLoading(true);

      try {
        const uploadResponse = await fileUploadNew(selectedFile);

        if (uploadResponse.status !== 201) {
          throw new Error(uploadResponse.message);
        }

        // const agreementResponse = await fileUploadAgreement(
        //   uploadResponse.data.file_id,
        // );

        // if (agreementResponse.status !== 200) {
        //   throw new Error(agreementResponse.message);
        // }

        // setFileState(agreementResponse.data.document);
      } catch (err) {
        setFileState(null);
        toastMessage = { message: err.message, type: "error" };
      } finally {
        setLoading(false);

        if (toastMessage) {
          setTimeout(() => {
            showToast(toastMessage.message, toastMessage.type);
          }, 300);
        }

        // Reset input
        if (inputRef?.current) inputRef.current.value = "";
      }
    };

  const checkFileNameExist = (selectedFile) => {
    const selectedName = selectedFile?.name?.toLowerCase();
    const files = [
      fileCrs,
      cashAccountAgreement,
      fileIndemnityForm,
      directDebitAgreement,
      smAgreement,
    ];
    return files.some((file) => file?.name?.toLowerCase() === selectedName);
  };
  const handleFileChangeCrs = createFileChangeHandler({
    inputRef: fileCrsRef,
    setFileState: setFileCrs,
  });
  const handleFileChangeCashAccount = createFileChangeHandler({
    inputRef: fileCashAccountRef,
    setFileState: setCashAccountAgreement,
  });
  const handleFileChangeForm = createFileChangeHandler({
    inputRef: fileFormRef,
    setFileState: setFileIndemnityForm,
  });
  const handleFileChangeDirectDebit = createFileChangeHandler({
    inputRef: fileDirectDebitRef,
    setFileState: setDirectDebitAgreement,
  });
  const handleFileChangeSma = createFileChangeHandler({
    inputRef: fileSmaRef,
    setFileState: setSmAgreement,
  });
  useEffect(() => {
    getSettingsData();
    getAllAgreements();
  }, []);
  const handleRateBlur = (index) => {
    const updatedRanges = [...ranges];
    const rateValue = parseFloat(updatedRanges[index].rate);

    if (isNaN(rateValue) || rateValue > 100) {
      updatedRanges[index].error =
        "Rate must be a number less than or equal to 100.";
    } else {
      updatedRanges[index].error = ""; // clear error
    }

    setRanges(updatedRanges);
  };
  return (
    <div>
      <div className="lg:min-w-[78vw] lg:max-w-[80vw]">
        {loading && (
          <div className="fixed top-0 left-0 w-full h-full flex justify-center items-center bg-black bg-opacity-50 z-[999]">
            <div className="w-12 h-12 border-4 border-white border-t-transparent rounded-full animate-spin"></div>
          </div>
        )}
        {isLoading ? (
          <div className="shimmer-container-list mb-4 ">
            {/* Creating 5 rows of shimmer effect */}
            {[...Array(2)].map((_, rowIndex) => (
              <div key={rowIndex} className="shimmer-row-list">
                {/* Creating 7 cells in each row for shimmer */}
                {[...Array(2)].map((_, colIndex) => (
                  <div key={colIndex} className="shimmer-cell-list h-20">
                    <div className="shimmer-loader"></div>
                  </div>
                ))}
              </div>
            ))}
          </div>
        ) : (
          <div>
            <div className="bg-white shadow-md rounded-md p-6">
              <div className="flex items-center justify-between border-b border-colour-custom pt-2 px-4">
                <h1 className="text-md font-medium mb-2 text-black text-center">
                  NAB Fees
                </h1>
              </div>
              <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-2 gap-6">
                <div className="flex flex-col px-4 pt-4">
                  <PercentageInputField
                    label="Direct Credit Fee"
                    name="directCredit"
                    value={directCredit}
                    setValue={setDirectCredit}
                    error={directCreditError}
                    setError={setDirectCreditError}
                    sign="$"
                  />
                  <PercentageInputField
                    label="Direct Debit Fee"
                    name="directDebit"
                    value={directDebit}
                    setValue={setDirectDebit}
                    error={directDebitError}
                    setError={setDirectDebitError}
                    sign="$"
                  />
                  <PercentageInputField
                    label="Domestic Payment/RTGS"
                    name="domesticPaymentRTGS"
                    value={domesticPayment}
                    setValue={setDomesticPayment}
                    error={domesticPaymentError}
                    setError={setDomesticPaymentError}
                    sign="$"
                  />
                </div>
                {/* center column */}
                <div className="flex flex-col lg:pt-4 pt-0  sm:border-l-0  md:border-l border-gray-300 px-4">
                  <PercentageInputField
                    label="International Payment With Currency Conversion"
                    name="internationalPaymentWithConversion"
                    value={internationalPaymentWithConversion}
                    setValue={setInternationalPaymentWithConversion}
                    error={internationalPaymentWithConversionError}
                    setError={setInternationalPaymentWithConversionError}
                    sign="$"
                  />
                  <PercentageInputField
                    label="International Payment Without Currency Conversion"
                    name="internationalPayment"
                    value={internationalPayment}
                    setValue={setInternationalPayment}
                    error={internationalPaymentError}
                    setError={setInternationalPaymentError}
                    sign="$"
                  />
                </div>
              </div>
            </div>
            <div className="bg-white shadow-md mt-4 rounded-md p-6">
              <div className="flex items-center justify-between border-b border-colour-custom pt-2 px-4">
                <h1 className="text-md font-medium mb-2 text-black text-center">
                  Bell direct Fees
                </h1>
              </div>
              <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-2 gap-2">
                <div className="flex flex-col px-4">
                  <PercentageInputField
                    label="Brokerage Fee"
                    name="brokerageFees"
                    value={brokerageFees}
                    setValue={setBrokerageFees}
                    error={brokerageFeesError}
                    setError={setBrokerageFeesError}
                    sign="$"
                  />

                  <label
                    htmlFor="ddedit"
                    className="mb-1 mt-4 text-sm text-labelColour"
                  >
                    Notes
                  </label>
                  <textarea
                    type="text"
                    name="documentId"
                    value={comments}
                    onChange={(e) => setComments(e.target.value)}
                    className="w-full resize-none bg-white text-black rounded-xl px-3 py-4 border border-gray-300"
                    placeholder="Add your comments"
                  />
                </div>
                {/* center column */}
                <div className="flex flex-col lg:pt-4 pt-0  sm:border-l-0  md:border-lb order-gray-300 px-4"></div>
              </div>
            </div>
            <div className="bg-white shadow-md mt-4 rounded-md p-6 space-y-6">
              <div className="flex items-center justify-between border-b">
                <h2 className="text-lg font-semibold text-black">
                  Administrator Fees
                </h2>
              </div>

              {ranges.map((row, index) => (
                <div
                  key={index}
                  className={`grid grid-cols-1 md:grid-cols-[40px_1fr_1fr_1fr] gap-4 items-start bg-slate-50 p-4 rounded-xl border-2 ${
                    row.error.start || row.error.end || row.error.rate
                      ? "border-[#DC4646]"
                      : "border-gray-200"
                  }`}
                >
                  {/* Row Number */}
                  <div className="flex items-start justify-center pt-8">
                    <div className="bg-gray-200 text-gray-700 text-xs font-semibold w-6 h-6 rounded-full flex items-center justify-center">
                      {String(index + 1).padStart(2, "0")}
                    </div>
                  </div>

                  {/* Start Range */}
                  <div className="relative">
                    <label className="block text-sm font-medium text-black mb-1">
                      FUM Start Range
                    </label>
                    <input
                      type="text"
                      className={`w-full px-3 py-2 border ${
                        row.error?.start
                          ? "border-[#DC4646]"
                          : "border-gray-300"
                      }
 rounded-md text-sm focus:ring-blue-500 focus:border-blue-500`}
                      placeholder="e.g., 0"
                      value={
                        row.start !== "" && row.start !== null
                          ? Number(row.start).toLocaleString("en-US")
                          : ""
                      }
                      onChange={(e) => {
                        const value = e.target.value.replace(/,/g, "");
                        if (!isNaN(value)) {
                          handleChange(index, "start", value);
                        }
                      }}
                    />
                    {row.error?.start && (
                      <p className="mt-1 text-xs text-[#DC4646] flex items-center gap-1">
                        <img
                          src="/danger.svg"
                          alt="error"
                          className="w-4 h-4"
                        />
                        {row.error.start}
                      </p>
                    )}
                  </div>

                  {/* End Range */}
                  <div className="relative">
                    <label className="block text-sm font-medium text-black mb-1">
                      FUM End Range
                    </label>
                    <input
                      type="text"
                      className={`w-full px-3 py-2 border ${
                        row.error?.end ? "border-[#DC4646]" : "border-gray-300"
                      } rounded-md text-sm focus:ring-blue-500 focus:border-blue-500`}
                      placeholder="e.g., 1000"
                      value={
                        row.end !== "" && row.end !== null
                          ? Number(row.end).toLocaleString("en-US")
                          : ""
                      }
                      onChange={(e) => {
                        const value = e.target.value.replace(/,/g, "");
                        if (!isNaN(value)) {
                          handleChange(index, "end", value);
                        }
                      }}
                    />
                    {row.error?.end && (
                      <p
                        className={`mt-1 text-xs text-[#DC4646] flex items-center gap-1`}
                      >
                        <img
                          src="/danger.svg"
                          alt="error"
                          className="w-4 h-4"
                        />
                        {row.error.end}
                      </p>
                    )}
                  </div>

                  {/* Rate */}
                  <div>
                    <label className="block text-sm font-medium text-black mb-1">
                      Rate (%)
                    </label>
                    <input
                      type="number"
                      step="0.01"
                      className={`w-full px-3 py-2 border ${
                        row.error?.end ? "border-[#DC4646]" : "border-gray-300"
                      } rounded-md text-sm focus:ring-blue-500 focus:border-blue-500`}
                      placeholder="e.g., 2.50"
                      value={row.rate}
                      onChange={(e) =>
                        handleChange(index, "rate", e.target.value)
                      }
                      onBlur={(e) => {
                        const formatted = parseFloat(e.target.value);
                        if (!isNaN(formatted)) {
                          handleChange(index, "rate", formatted.toFixed(2));
                        }
                      }}
                    />
                    {row.error?.rate && (
                      <p className="text-red-600 text-xs mt-1">
                        {row.error.rate}
                      </p>
                    )}
                  </div>
                </div>
              ))}
            </div>
            <div className="bg-white shadow-md rounded-md p-6 mt-4">
              <div className="flex items-center justify-between border-b border-colour-custom pt-2 px-4">
                <h1 className="text-md font-medium mb-2 text-black text-center">
                  Other Fees
                </h1>
              </div>
              <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 gap-6">
                <div className="flex flex-col px-4">
                  <PercentageInputField
                    label="Custody Fee"
                    name="custodyFee"
                    value={custodyFee}
                    setValue={setCustodyFee}
                    error={custodyFeeError}
                    setError={setCustodyFeeError}
                    sign="%"
                  />
                </div>
                {/* center column */}
                <div className="flex flex-col sm:border-l-0  md:border-l   border-gray-300 px-4">
                  <PercentageInputField
                    label="Account Keeping Fee"
                    name="accountKeepingFee"
                    value={accountKeepingFee}
                    setValue={setAccountKeepingFee}
                    error={accountKeepingFeeError}
                    setError={setAccountKeepingFeeError}
                    sign="%"
                  />
                </div>
                <div className="flex flex-col   sm:border-l-0  md:border-l   border-gray-300 px-4">
                  <PercentageInputField
                    label="Management Cost"
                    name="managementCost"
                    value={managementCost}
                    setValue={setManagementCost}
                    error={managementCostError}
                    setError={setManagementCostError}
                    sign="%"
                  />
                </div>
              </div>
            </div>
            <div className="bg-white shadow-md mt-4 rounded-md p-6">
              <div className="flex items-center justify-between border-b border-colour-custom pt-2 px-4">
                <h1 className="text-md font-medium mb-2 text-black text-center">
                  Product Allocation
                </h1>
              </div>
              <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-2 gap-6">
                <div className="flex flex-col px-4 pt-4">
                  <PercentageInputField
                    label="Change Allocation Percentage Limit"
                    name="productAllocation"
                    value={productAllocation}
                    setValue={setProductAllocation}
                    error={productAllocationError}
                    setError={setProductAllocationError}
                    sign="%"
                  />
                </div>
                {/* center column */}
                <div className="flex flex-col lg:pt-4 pt-0  sm:border-l-0  md:border-lb order-gray-300 px-4"></div>
              </div>
            </div>
            <div className="bg-white shadow-md mt-4 rounded-md p-6">
              <div className="flex items-center justify-between border-b border-colour-custom pt-2 px-4">
                <h1 className="text-md font-medium mb-2 text-black text-center">
                  Transaction Execution Time
                </h1>
              </div>
              <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-2 gap-6">
                <div className="flex flex-col px-4 pt-4">
                  <label
                    htmlFor="dcredit"
                    className="mb-1 text-sm text-labelColour"
                  >
                    Start Time
                  </label>
                  <input
                    type="time"
                    name="startTime"
                    value={startTime}
                    onChange={(e) => setStartTime(e.target.value)}
                    className="p-2 text-black w-full font-medium border border-gray-300 rounded-md text-md"
                  />
                </div>
                {/* center column */}
                <div className="flex flex-col lg:pt-4 pt-0  sm:border-l-0  md:border-l border-gray-300 px-4">
                  <label
                    htmlFor="dcredit"
                    className="mb-1 text-sm text-labelColour"
                  >
                    End Time
                  </label>
                  <input
                    type="time"
                    name="endTime"
                    value={endTime}
                    onChange={(e) => setEndTime(e.target.value)}
                    className="p-2 text-black w-full font-medium border border-gray-300 rounded-md text-md"
                  />
                </div>
              </div>
            </div>
            <div className="bg-white shadow-md mt-4 rounded-md p-6">
              <div className="border-b pb-3 mb-6">
                <h1 className="text-md font-medium text-black">Agreements</h1>
              </div>

              <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 gap-6">
                {agreements.map((agreement) => (
                  <UploadAgreementCard
                    key={agreement.agreement_type.enum}
                    agreement={agreement}
                    refreshAgreements={getAllAgreements}
                  />
                ))}
              </div>
            </div>

            <div className="flex items-center mt-6 p-4 bg-[#005A9C]">
              <div className="flex items-center justify-start w-full space-x-4">
                <div
                  onClick={(e) => {
                    e.preventDefault();
                    const hasError = ranges.some((range) =>
                      Object.values(range.error || {}).some(
                        (msg) => typeof msg === "string" && msg.trim() !== ""
                      )
                    );
                    if (hasError) {
                      showToast(
                        "Please ensure all administration fee ranges are valid.",
                        "error"
                      );
                      return;
                    }
                    if (directDebitError != "") {
                      showToast(
                        "Please enter a valid Direct Debit Fee",
                        "error"
                      );
                      return;
                    }
                    if (directCreditError != "") {
                      showToast(
                        "Please enter a valid Direct Credit Fee",
                        "error"
                      );
                      return;
                    }
                    if (domesticPaymentError != "") {
                      showToast(
                        "Please enter a valid Domestic Payment/RTGS Fee",
                        "error"
                      );
                      return;
                    }
                    if (internationalPaymentWithConversionError != "") {
                      showToast(
                        "Please enter a valid international payment With currency conversion fee",
                        "error"
                      );
                      return;
                    }
                    if (internationalPaymentError != "") {
                      showToast(
                        "Please enter a valid international payment without currency conversion fee",
                        "error"
                      );
                      return;
                    }
                    if (managementCostError != "") {
                      showToast(
                        "Please enter a valid management cost",
                        "error"
                      );
                      return;
                    }
                    if (accountKeepingFeeError != "") {
                      showToast(
                        "Please enter a valid account keeping fee",
                        "error"
                      );
                      return;
                    }
                    if (brokerageFeesError != "") {
                      showToast("Please enter a valid brokerage fee", "error");
                      return;
                    }
                    if (custodyFeeError != "") {
                      showToast("Please enter a valid custody fee", "error");
                      return;
                    }
                    if (productAllocationError != "") {
                      showToast(
                        "Please enter a valid product allocation limit value",
                        "error"
                      );
                      return;
                    }
                    setLoading(true);
                    handleUpdateTransacion(e);
                  }}
                  className="flex border ml-6 rounded-full items-center space-x-2 text-sm md:text-md font-medium py-1 px-8 text-white cursor-pointer"
                >
                  <span>Update settings</span>
                </div>
                <div
                  onClick={(e) => {
                    e.preventDefault();
                    getSettingsData();
                  }}
                  className="flex border ml-6 rounded-full items-center space-x-2 text-sm md:text-md font-medium py-1 px-8 text-white cursor-pointer"
                >
                  <span>Reset</span>
                </div>
              </div>
            </div>
          </div>
        )}
      </div>
    </div>
  );
};
const UploadAgreementCard = ({ agreement, refreshAgreements }) => {
  const [uploadedFile, setUploadedFile] = useState(agreement.document || null);
  const navigate = useNavigate();
    const { showToast } = useToast();
      const [currentDocument, setcurrentDocument] = useState({});
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [loading, setLoading] = useState(false);
    const handleFileClick = (e, rowData) => {
    setcurrentDocument(rowData);
    setIsModalOpen(true);
  };
  const enumKey = agreement.agreement_type.id;
  const fileUploadNew = async (file) => {
    const token = localStorage.getItem("jwtToken");
    const headers = {};

    if (token) {
      headers.Authorization = `Bearer ${token}`;
    }
    const apiUrl = `${BASE_URL}/v1/onboarding/upload/file`;
    const formData3 = new FormData();
    formData3.append("file", file); // Append file
    try {
      const response = await fetch(apiUrl, {
        method: "POST",
        headers,
        body: formData3,
      });
      if (!response.ok) {
        if (response.status === 401) {
          localStorage.removeItem("jwtToken");
          navigate("/login");
          throw new Error("Session expired. Please log in again.");
        }
        const errorData = await response.json().catch(() => ({
          message: "An unexpected error occurred",
        }));
        throw new Error(errorData.message || "Something went wrong");
      }
      return await response.json();
    } catch (error) {
      console.error("API Call Error:", error); // Log full error for debugging
      throw new Error(
        typeof error.message === "string"
          ? error.message
          : "Network error, please try again later"
      );
    }
  };
  const fileUploadAgreement = async (file, agreementType) => {
    const token = localStorage.getItem("jwtToken");
  const headers = {
    "Content-Type": "application/json",
  };
    if (token) {
      headers.Authorization = `Bearer ${token}`;
    }
    const apiUrl = `${BASE_URL}/v1/onboarding/agreements/admin/${agreementType}/document`;
    let bodyData = {
      file_id: file,
    };
    try {
      const response = await fetch(apiUrl, {
        method: "PUT",
        headers,
        body: JSON.stringify(bodyData),
      });
      if (!response.ok) {
        if (response.status === 401) {
          localStorage.removeItem("jwtToken");
          navigate("/login");
          throw new Error("Session expired. Please log in again.");
        }
        const errorData = await response.json().catch(() => ({
          message: "An unexpected error occurred",
        }));
        throw new Error(errorData.message || "Something went wrong");
      }
      return await response.json();
    } catch (error) {
      console.error("API Call Error:", error); // Log full error for debugging
      throw new Error(
        typeof error.message === "string"
          ? error.message
          : "Network error, please try again later"
      );
    }
  };
  const handleFileChange = async (e) => {
    const file = e.target.files[0];
    if (!file) return;

    setLoading(true);

    try {
      // 1️⃣ Upload file
      const uploadResponse = await fileUploadNew(file);

      if (uploadResponse.status !== 201) {
        throw new Error(uploadResponse.message || "File upload failed");
      }

      // 2️⃣ Attach file to agreement
      const agreementResponse = await fileUploadAgreement(
        uploadResponse.data.file_id,
        enumKey
      );

      if (agreementResponse.status !== 200) {
        throw new Error(agreementResponse.message || "Agreement upload failed");
      }

      // 3️⃣ Update state with document info
     refreshAgreements();
    } catch (err) {
      showToast(err.message,"error");
    } finally {
      setLoading(false);
    }

    e.target.value = "";
  };

  const handleDelete = () => {
    setUploadedFile(null);
  };

  return (
    <div className="flex flex-col">
      <label className="mb-1 text-sm text-labelColour">
        {agreement.agreement_type.name}
        {agreement.is_required && <span className="text-red-500 ml-1">*</span>}
      </label>

      <label className="border-2 border-dashed rounded-lg p-6 mt-2 block text-center cursor-pointer flex flex-col items-center">
        <input
          type="file"
          accept=".pdf,.png,.jpeg"
          className="hidden"
          onChange={handleFileChange}
          disabled={loading}
        />
        <img src="/folder-add.svg" className="h-4 w-4" />
        <p className="mt-2 text-gray-500 text-sm">
          {loading ? "Uploading..." : "Drag & Drop or Click to Upload"}
        </p>
      </label>

      <div className="mt-1 flex flex-wrap gap-2">
        {["PNG", "JPEG", "PDF", "< 10 MB"].map((t) => (
          <span
            key={t}
            className="bg-[#8E8E8E] text-white px-2 py-1 rounded-md text-xs"
          >
            {t}
          </span>
        ))}
      </div>

      {agreement?.preview_document && (
        <div className="border mt-4 bg-white shadow-md rounded-lg flex items-center justify-between px-3 py-2">
          <span
            onClick={(e) => handleFileClick(e,agreement.preview_document)}
            className="text-black cursor-pointer underline"
          >
            {agreement.preview_document.name}
          </span>
{/* 
          <button onClick={handleDelete} disabled={loading}>
            <img src="/trash.svg" className="h-4 w-4" />
          </button> */}
        </div>
      )}
            {isModalOpen && currentDocument && (
        <DocumentPreview
          fileUrl={currentDocument.presigned_url}
          fileName={currentDocument?.file_name || currentDocument?.name}
          onClose={() => setIsModalOpen(false)}
        />
      )}
    </div>
  );
};

export default ProductSettings;
